import {SectionView} from './SectionView'
import {PIXI} from '@colonist/pixi'
import {ViewAnimationController} from './ViewAnimationController'
import {ViewAnimationControllerAdapter} from './animation/ViewAnimationControllerAdapter'

export class MovingSectionView extends SectionView {
    readonly animationController: ViewAnimationController

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, removePadding: boolean = true) {
        super(x, y, w, h, container, removePadding)

        this.animationController = new ViewAnimationControllerAdapter(this)
    }
}
